import React from 'react';
import { AlertOctagon, FileSignature, Hourglass } from 'lucide-react';

// Renders a payment error: either plain text or the structured "membership lapsed" refusal with its re-join button.
export function PaymentError({ err, testid = 'payment-error', className = 'text-sm mb-4 px-3 py-2 rounded' }) {
  if (!err) return null;
  const lapsed = typeof err === 'object' && err.code === 'membership_lapsed';
  if (!lapsed) {
    const text = typeof err === 'string' ? err : (err.message || err.detail || 'Something went wrong.');
    return <p className={className} style={{ background: '#fdecea', color: '#8a1f11' }} data-testid={testid}>{text}</p>;
  }
  const onHold = !!err.on_hold;
  return (
    <div className="rounded-lg p-4 mb-4 text-sm" style={{ background: onHold ? '#fff4e5' : '#fdecea', border: `1px solid ${onHold ? '#e0b34d' : '#e8a39a'}`, color: onHold ? '#5a3d05' : '#5a1a12' }} data-testid={`${testid}-lapsed`}>
      <div className="flex items-start gap-2">
        {onHold ? <Hourglass size={18} className="mt-0.5 shrink-0" style={{ color: '#8a5a00' }} /> : <AlertOctagon size={18} className="mt-0.5 shrink-0" style={{ color: '#8a1f11' }} />}
        <div>
          <div className="font-title mb-1" style={{ color: onHold ? '#8a5a00' : '#8a1f11' }}>{onHold ? 'Membership on hold — executive approval requested' : 'Membership lapsed — payment not accepted'}</div>
          <p className="mb-2" data-testid={`${testid}-lapsed-message`}>{err.message}</p>
          {err.apply_url && (
            <a href={err.apply_url} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded font-title" style={{ background: 'var(--maroon)', color: 'var(--cream)' }} data-testid={`${testid}-apply-link`}>
              <FileSignature size={14} /> {onHold ? 'Or re-apply now (pre-filled)' : 'Apply to re-join (pre-filled)'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export const errDetail = (e, fallback) => e?.response?.data?.detail || fallback;
